import type { FeatureTypeEnum } from '@/api/hanly/hanlyAPI.schemas';
import { isFeatureEnabled } from '@/contexts/auth-context';
import { useAuth } from './auth';

/**
 * 機能フラグを扱うためのカスタムフック
 */
export const useFeatureFlag = () => {
  const { featureFlags } = useAuth();

  /**
   * 指定された機能が有効かどうかを判定
   */
  const isEnabled = (featureType: FeatureTypeEnum): boolean => {
    return isFeatureEnabled(featureFlags, featureType);
  };

  return {
    featureFlags,
    isEnabled,
  };
};
